import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDateInTimezone, parseDay, timeZone } from '@packages/shared';
import { Actions } from '@packages/types';
import { cva } from 'class-variance-authority';
import { enGB, nb } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';
import { useRouter } from 'next/router';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';
export default function DateButton({ day, selectedDay, className, isAvailable, onClick, i18nFunction, trackingEvent, }) {
    const dateFnsLocale = useRouter().locale === 'en' ? enGB : nb;
    const t = i18nFunction;
    const isDisabled = !isAvailable;
    const [dayNumber, dayName, monthName] = formatInTimeZone(parseDay(day), timeZone, 'dd-E-MMM', { locale: dateFnsLocale }).split('-');
    const isSelected = day === selectedDay;
    const isToday = getDateInTimezone() === day;
    const buttonStyle = cva(['w-full', className], {
        variants: {
            intent: {
                selected: [
                    'selected',
                    'bg-accent',
                    'ring-offset-primary',
                    'ring-2',
                    'text-black',
                    'ring-offset-2',
                    'outline-none',
                    'ring-accent',
                ],
                disabled: ['bg-black/20', 'text-white'],
                default: ['bg-white', 'text-black', 'hover:bg-accent'],
            },
        },
    });
    const handleClick = () => {
        if (isDisabled) {
            trackingEvent(Actions.SelectDateButtonDisabled, day);
            return;
        }
        onClick(day);
    };
    let testId = 'date-button';
    if (isSelected) {
        testId = 'date-button-selected';
    }
    else if (isDisabled) {
        testId = 'date-button-disabled';
    }
    return (_jsxs(Tooltip, { isAvailable: isAvailable, children: [_jsx(TooltipTrigger, { asChild: true, children: _jsxs("button", { id: `date-button-${day}`, onClick: handleClick, className: buttonStyle({
                        intent: isSelected
                            ? 'selected'
                            : isDisabled
                                ? 'disabled'
                                : 'default',
                    }), "aria-disabled": isDisabled ? 'true' : undefined, "data-testid": testId, children: [_jsx("span", { className: "text-[15px] leading-5", children: isToday ? t('today') : dayName }), _jsx("span", { className: "font-medium leading-5", children: dayNumber }), _jsx("span", { className: "text-[15px] leading-5", children: monthName })] }, day) }), _jsx(TooltipContent, { children: _jsx("div", { className: "w-fit-content h-auto max-w-[120px] rounded-md bg-white p-2 text-center text-xs text-black shadow-md", children: t('steps.select_datetime.tooltip.date.no_available', {
                        ns: 'booking',
                    }) }) })] }));
}
